const NPCardType = Object.freeze({
  TEMPLATE: 'TEMPLATE',
  CUSTOM: 'CUSTOM'
})
export default NPCardType
// RESERVE BELOW
